import styled from 'styled-components';
import { H4Text } from '@prisjakt/ui/text/variants';
import { layout } from '@prisjakt/ui-base';

const ILLUSTRATION_MAX_HEIGHT = 100;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${layout.measurements.spacing100};
`;

export const StyledContent = styled.div`
  display: grid;
  grid-row-gap: ${layout.measurements.spacing050};
  height: fit-content;
`;

export const StyledIllustration = styled.img`
  max-height: ${ILLUSTRATION_MAX_HEIGHT}px;
  width: auto;
  height: auto;
  margin-right: ${layout.measurements.spacing100};
`;

export const StyledTitle = styled(H4Text)`
  margin: 0;
`;
